export default __webpack_public_path__ + "static/media/p5.634bac71.png";